import Cookies from 'js-cookie'
const TokenKey = 'Rec-Token'
const RefreshTokenKey = 'Rec-RefreshToken'
const StorageKey = 'Rec-Storage'
const redirectKey = 'Rec-Redirect'

// token
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// refresh-token
export function getRefreshToken() {
  let refresh_token = Cookies.get(RefreshTokenKey)
  return refresh_token ? refresh_token : false
}

export function setRefreshToken(refreshToken) {
  return Cookies.set(RefreshTokenKey, refreshToken)
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey)
}

// storage
export function getStorage() {
  return Cookies.get(StorageKey)
}

export function setStorage(storage) {
  return Cookies.set(StorageKey, storage)
}

export function removeStorage() {
  return Cookies.remove(StorageKey)
}

// redirect
export function getRedirect() {
  return Cookies.get(redirectKey)
}

export function setRedirect(redirect) {
  return Cookies.set(redirectKey,redirect)
}

export function removeRedirect() {
  return Cookies.remove(redirectKey)
}